/**
 * Liest Zahleneingaben robust ein (deutsch und international):
 * "87,5" / "87.5" -> 87.5, "1.500" / "1.500,50" -> 1500 / 1500.5, "1,500.50" -> 1500.5.
 * Gibt null zurück, wenn leer oder keine gültige Zahl.
 */
export const parseDecimal = (v: string | null | undefined): number | null => {
  let t = (v ?? "").trim().replace(/\s|€|h/gi, "");
  if (!t) return null;
  const hasComma = t.includes(",");
  const hasDot = t.includes(".");
  if (hasComma && hasDot) {
    // Das zuletzt stehende Zeichen ist das Dezimalzeichen.
    t = t.lastIndexOf(",") > t.lastIndexOf(".")
      ? t.replace(/\./g, "").replace(",", ".")
      : t.replace(/,/g, "");
  } else if (hasComma) {
    t = /^-?\d{1,3}(,\d{3}){2,}$/.test(t) ? t.replace(/,/g, "") : t.replace(",", ".");
  } else if (hasDot && /^-?\d{1,3}(\.\d{3})+$/.test(t)) {
    // Deutsche Tausenderpunkte wie "1.500" oder "12.000".
    t = t.replace(/\./g, "");
  }
  if (!/^-?\d+(\.\d+)?$/.test(t)) return null;
  return Number(t);
};

/** Zahl für Eingabefelder im deutschen Format (Komma als Dezimalzeichen). */
export const toInputDecimal = (n: number | null | undefined): string =>
  n == null ? "" : String(n).replace(".", ",");
